import React, { useState } from 'react';
import api from "../Api";
import './StripeCheckout.css';

const StripeCheckout = ({ plan, subscriptionId, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get auth token
  const getAuthToken = () => {
    return localStorage.getItem('technician_token');
  };

  const handleCheckout = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getAuthToken();
      if (!token) {
        setError('Please login to continue');
        return;
      }

      // Remove /api from path since api.js already has baseURL
      const response = await api.post('/api/web/create-checkout-session', {
        subscriptionId: subscriptionId,
        planId: plan._id,
      }, {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = response.data;
      
      if (result.success && result.data && result.data.url) {
        // Redirect to Stripe checkout
        window.location.href = result.data.url;
      } else {
        setError('Failed to create checkout session');
      }
    } catch (err) {
      console.error('Checkout error:', err);
      setError(err.response?.data?.message || 'Failed to initiate payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stripe-modal-overlay">
      <div className="stripe-modal" role="dialog" aria-modal="true" aria-labelledby="stripe-modal-title">
        <button type="button" className="stripe-modal-close" onClick={onClose} aria-label="Close payment dialog">×</button>
        
        <div className="stripe-modal-content">
          <div className="stripe-payment-header">
            <div className="stripe-modal-badge" aria-hidden="true">✓</div>
            <span className="stripe-modal-eyebrow">Secure checkout</span>
            <h2 id="stripe-modal-title">Complete your subscription</h2>
            <p>Review your plan and continue to secure payment.</p>
          </div>

          <div className="stripe-order-summary">
            <h3>Order summary</h3>
            <div className="stripe-plan-details">
              <div className="stripe-plan-name">
                <strong>{plan.name.toUpperCase()} Plan</strong>
                <span>{plan.duration_in_days} days of access</span>
              </div>
              <div className="stripe-plan-price">
                <span className="stripe-amount">${plan.price}</span>
              </div>
            </div>
            <div className="stripe-plan-features">
              <p><span aria-hidden="true">✓</span> Full access to all features</p>
              <p><span aria-hidden="true">✓</span> Priority support</p>
              <p><span aria-hidden="true">✓</span> Cancel anytime</p>
            </div>
            <div className="stripe-total-amount">
              <span>Total due today</span>
              <strong>${plan.price}</strong>
            </div>
          </div>

          {error && (
            <div className="stripe-payment-error" role="alert">
              <p>{error}</p>
            </div>
          )}

          <button 
            className="stripe-pay-button" 
            onClick={handleCheckout}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="stripe-spinner" aria-hidden="true"></span>
                Processing...
              </>
            ) : (
              <>Continue to payment <span aria-hidden="true">→</span></>
            )}
          </button>

          <div className="stripe-secure-payment">
            <span className="stripe-lock-icon" aria-hidden="true">▣</span>
            <p>Secure, encrypted payment powered by <strong>Stripe</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeCheckout;